module.exports = __webpack_public_path__ + "static/media/logotip.40faced4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/webportal/theme/images/logotip.svg
// module id = 751
// module chunks = 1